var React = require('react');

function Soundcloud2 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"soundcloud2"),React.createElement("path",{"d":"M29 0h-26c-1.65 0-3 1.35-3 3v26c0 1.65 1.35 3 3 3h26c1.65 0 3-1.35 3-3v-26c0-1.65-1.35-3-3-3zM5.5 22h-1l-0.5-3 0.5-3h1l0.5 3-0.5 3zM9.5 22h-1l-0.5-4 0.5-4h1l0.5 4-0.5 4zM13.5 22h-1l-0.5-6 0.5-6h1l0.5 6-0.5 6zM25.788 22c-0.063 0-9.413-0.006-9.419-0.006-0.2-0.019-0.363-0.194-0.369-0.4v-10.787c0-0.2 0.069-0.3 0.325-0.4 0.663-0.256 1.406-0.406 2.175-0.406 3.131 0 5.7 2.4 5.975 5.469 0.406-0.169 0.85-0.262 1.313-0.262 1.875 0 3.4 1.525 3.4 3.4s-1.525 3.394-3.4 3.394z","key":1})]);
}

Soundcloud2.defaultProps = {"version":"1.1","width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Soundcloud2;

Soundcloud2.default = Soundcloud2;
